import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {filterPreset_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterPreset_template";

declare var ko: any;
declare var page: any;

export class jobApplicationsList_template extends vnTemplate {

    protected filter: filterSimple_template;
    protected pagination: pagination_template;
    protected filterBrandType: multipleSelector_template;
    protected filterProfileType: multipleSelector_template;
    protected filterStatusType: multipleSelector_template;
    protected filterHrStatusType: multipleSelector_template;
    protected resultInfos: resultsInfo_template;
    protected filterPreset: filterPreset_template;
    protected initialPreferences;

    protected getTemplateHtml(): string {

        return `
            <div class="sub-header filter-preset w-justify" data-bind="visible: !isCandidate()">

                    ` + this.filterPreset.getHtmlBuild() + `

            </div>
            <div class="sub-header w-justify" data-bind="visible: !isCandidate()">
                <div class="w-left">
                    ` + this.filterBrandType.getHtmlBuild() + ` 
                    ` + this.filterProfileType.getHtmlBuild() + `
                    ` + this.filterStatusType.getHtmlBuild() + ` 
                    ` + this.filterHrStatusType.getHtmlBuild() + ` 
                    
                </div>
            </div>
            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-brandType"></div>
                </div>
            </div> 
            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-profileType"></div>
                </div>
            </div>
            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-statusType"></div>
                </div>
            </div>
            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-hrStatusType"></div>
                </div>
            </div>
            
            <div class="list-header w-justify" data-bind="visible: !isCandidate()" >
                <div class="w-left">
                    <button data-bind="event: {  click: onClickTogglePreferences.bind($data, 'open') }" class="btn secondary icon i-notification" type="button">Notification Config</button>
                </div>
                <div class="w-center">
                         ` + this.filter.getHtmlBuild() + `
                </div>

                <div class="w-right">
                    <div data-bind="style: { display: paginationIsVisible() ? 'block' : 'none' }">
                        <div id="pagination" class="w-pagination" data-bind="template: { name: 'pagination-template', data: pagination }">
                            <div class="pagination">
                                <input data-bind="value: pageNumber" type="hidden" value="1">
                                <span><a data-bind="event: { click: onClickPageFirst }" class="hidden prev">first</a></span>
                                <ul data-bind="foreach: pages">
                                    <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page active">1</a></li>

                                    <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">2</a></li>

                                    <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">3</a></li>
                                </ul>
                                <span><a data-bind="event: { click: onClickPageLast }" class="hidden next">last</a></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- ko if: isCandidate()  -->
            <div class="w-text">
                <div id="myModal">
                    <p class="text emp">Welcome to <strong>Emaki CMS</strong> (Content Management System).  Thank you for your interest in a position with us.  By clicking on one of your applications listed below, you will find instructions on how to complete and submit your application for consideration.</p>
                </div>  
            </div>           
            <!-- /ko -->
            
            <div class="w-list-results" id="list-results">
                <table class="list-results">
                 ` + this.resultInfos.getHtmlBuild() + `
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'brand.name') }, css: { 'list-sort-desc': orderByAndDirection()=='brand.name_DESC', 'list-sort-asc': orderByAndDirection()=='brand.name_ASC' }">Brand</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'candidate.fullName') }, css: { 'list-sort-desc': orderByAndDirection()=='candidate.fullName_DESC', 'list-sort-asc': orderByAndDirection()=='candidate.fullName_ASC' }">Candidate</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'profile.name') }, css: { 'list-sort-desc': orderByAndDirection()=='profile.name_DESC', 'list-sort-asc': orderByAndDirection()=='profile.name_ASC' }">Position Title</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'applicationStatus.name') }, css: { 'list-sort-desc': orderByAndDirection()=='applicationStatus.name_DESC', 'list-sort-asc': orderByAndDirection()=='applicationStatus.name_ASC' }">Application Status</span></th>
                            <!-- ko if: permissions()['job_application_status'].read || permissions()['job_application_hr_flag'].read -->
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'candidate.idHrStatus') }, css: { 'list-sort-desc': orderByAndDirection()=='candidate.idHrStatus_DESC', 'list-sort-asc': orderByAndDirection()=='candidate.idHrStatus.name_ASC' }">Hr Status</span></th>
                            <!-- /ko -->
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'candidate.dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='candidate.dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='candidate.dateCreated_ASC' }">Date Created</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'candidate.dateUpdated') }, css: { 'list-sort-desc': orderByAndDirection()=='candidate.dateUpdated_DESC', 'list-sort-asc': orderByAndDirection()=='candidate.dateUpdated_ASC' }">Date Updated</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: applications">
                        <tr  class="cursor">
                            <td data-bind="event: { click: $parent.onClickView }" class="brands"><a class="right-click" data-bind="attr: { href : emakiView }"><span class="dark" data-bind="css: iconImage, text: brandName"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: candidateName"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: positionName"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: applicationStatus"></span></a></td>
                             <!-- ko if: $parent.permissions()['job_application_status'].read || $parent.permissions()['job_application_hr_flag'].read -->
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: hrStatus"></span></a></td>
                            <!-- /ko -->
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: dateCreated"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: dateUpdated"></span></a></td>
                        </tr>
                    </tbody>
                </table>
            </div> 
            
            <div id="preferences-dialog" class="w-lightbox light-theme">
                    <div class="lightbox-content">
                        
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title icon i-notification">Notification Preferences</h3>
                            <button data-bind="event: { click: onClickTogglePreferences.bind($data, 'cancel') }" type="button" class="close-button icon i-close-2"></button>
                        </div>
                        
                        <div class="form-body form-body-scroll">
                            <table id="spec_section_list" class="list-action full-width" data-bind="visible: preferences().length > 0">
                                <thead>
                                    <tr >
                                        <th class="short"></th>  
                                        <th><span>Candidate Comments</span></th>
                                        <th><span>Application Submissions</span></th>
                                        <th><span>HR Approvals</span></th>
                                        <th><span>Application Approvals</span></th>
                                        <th><span>Application Rejections</span></th>
                                    </tr>
                                </thead>
                                <tbody data-bind="foreach: preferences">
                                    <tr class="form-row">       
                                        <td class="brands">
                                            <span class="dark full-icon" data-bind="css: brand.iconImage"></span> 
                                        </td>
                                        <td>
                                            <input type="checkbox" data-bind="checked: candidateComments, attr: {id: 'candidateComments' + $index()}">
                                            <label class="icon i-check" for="candidateComments" data-bind="attr: {for: 'candidateComments' + $index()}"></label> 
                                        </td>
                                        <td>
                                            <input type="checkbox" data-bind="checked: applicationSubmissions, attr: {id: 'applicationSubmissions' + $index()}">
                                            <label class="icon i-check" for="applicationSubmissions" data-bind="attr: {for: 'applicationSubmissions' + $index()}"></label> 
                                        </td>
                                        <td>
                                            <input type="checkbox" data-bind="checked: hrApprovals, attr: {id: 'hrApprovals' + $index()}">
                                            <label class="icon i-check" for="hrApprovals" data-bind="attr: {for: 'hrApprovals' + $index()}"></label> 
                                        </td>
                                        <td>
                                            <input type="checkbox" data-bind="checked: applicationApprovals, attr: {id: 'applicationApprovals' + $index()}">
                                            <label class="icon i-check" for="applicationApprovals" data-bind="attr: {for: 'applicationApprovals' + $index()}"></label> 
                                        </td>
                                        <td>
                                            <input type="checkbox" data-bind="checked: applicationRejections, attr: {id: 'applicationRejections' + $index()}">
                                            <label class="icon i-check" for="applicationRejections" data-bind="attr: {for: 'applicationRejections' + $index()}"></label> 
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                
                        <div class="form-footer">
                            <button class="btn" type="button" data-bind="event: { click: onClickTogglePreferences.bind($data, 'cancel') }">Cancel</button>
                            <button class="btn highlight" type="button" data-bind="event:{click: onClickSavePreferences}">Save</button>
                        </div>
                    </div>
                   
                </div>
                </div> 
            
            `;
    }

    protected initPartial(): void {

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);

        this.filterBrandType = new multipleSelector_template("filterBrandType", this.getTemplateViewModel(), this.caller);
        this.filterBrandType.setLabel("brand");
        this.filterBrandType.setFilterContainerClass('margin-neg');
        this.filterBrandType.setTagContainerId('selected-brandType');
        this.filterBrandType.setTagContainerCaption('Selected brand type:');

        this.filterProfileType = new multipleSelector_template("filterProfileType", this.getTemplateViewModel(), this.caller);
        this.filterProfileType.setLabel("profile");
        this.filterProfileType.setFilterContainerClass('margin-neg');
        this.filterProfileType.setTagContainerId('selected-profileType');
        this.filterProfileType.setTagContainerCaption('Selected profile type:');
        this.filterProfileType.setSelectAllEnabled(false);
        this.filterProfileType.setSearchEnabled(true);

        this.filterStatusType = new multipleSelector_template("filterStatusType", this.getTemplateViewModel(), this.caller);
        this.filterStatusType.setLabel("Application Status");
        this.filterStatusType.setFilterContainerClass('margin-neg');
        this.filterStatusType.setTagContainerId('selected-statusType');
        this.filterStatusType.setTagContainerCaption('Selected status type:');

        this.filterHrStatusType = new multipleSelector_template("filterHrStatusType", this.getTemplateViewModel(), this.caller);
        this.filterHrStatusType.setLabel("HR Status");
        this.filterHrStatusType.setFilterContainerClass('margin-neg');
        this.filterHrStatusType.setTagContainerId('selected-hrStatusType');
        this.filterHrStatusType.setTagContainerCaption('Selected hr status type:');

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);

        this.filterPreset = new filterPreset_template("filterPreset", this.getTemplateViewModel(), this.caller);
        this.filterPreset.getTemplateViewModel().searchPresetType('jobApplication');
    }

    protected getTemplateName(): string {
        return "jobApplicationsList-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return {
             orderBy: ko.observable("candidate.dateCreated")
            ,orderByDirection: ko.observable("DESC")
            ,orderByAndDirection: ko.observable("candidate.dateCreated_DESC")
            ,applications: ko.observableArray([])
            ,permissions: ko.observableArray(this.initPermissions(['job_application_hr_flag', 'job_application_status']))
            ,isCandidate: ko.observable(false)
            ,preferences: ko.observableArray([])
            ,paginationIsVisible: ko.observable(false)
            , onClickReorder: function (value, data, event) {
                huit_neuf_this.onClickReorder(value, data, event);
            },
            onClickView: function (data, event) {
                huit_neuf_this.onClickView(data)
            },
            onClickTogglePreferences: function (type, data, event) {
                 huit_neuf_this.onClickTogglePreferences(type);
             },
            onClickSavePreferences: function (data, event) {
                 huit_neuf_this.onClickSavePreferences(); }
        };
    }

    // implementation of base class [vnTemplate]
    public getViewModelForRequest() {

        return {
            orderBy: this.getTemplateViewModel().orderBy
            , orderByDirection: this.getTemplateViewModel().orderByDirection
            , orderByAndDirection: this.getTemplateViewModel().orderByAndDirection
            , pagination: this.getTemplateViewModel().pagination
            , searchPresetName: this.getTemplateViewModel().filterPreset.searchPresetName()
            , searchPresetType: this.getTemplateViewModel().filterPreset.searchPresetType()
            , filters      : {
                keywords : this.getTemplateViewModel().filter.filterKeyword,
                brandIds: this.viewModel.list.filterBrandType.selectedItems,
                statusIds: this.viewModel.list.filterStatusType.selectedItems,
                hrStatusIds: this.viewModel.list.filterHrStatusType.selectedItems,
                profileIds: this.viewModel.list.filterProfileType.selectedItems,
            },
        }
    }

    public onClickReorder(value, data, event) {

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.listReorder();
    }

    public onClickView(profile){

        this.caller.viewApplication(profile);
    }

    public onClickTogglePreferences(type) {

        document.getElementById('preferences-dialog').classList.toggle('is-visible');

        //reset to original preferences
        if(type == 'cancel'){
            let preferences = JSON.parse(JSON.stringify(this.initialPreferences));
            this.getTemplateViewModel().preferences([]);
            this.getTemplateViewModel().preferences(preferences);
        }
    }

    public onClickSavePreferences() {

        this.caller.savePreferences();
    }

    public setApplications(applications) {
        applications.forEach((a) => a['emakiView'] = '/job/applications/view/' + a.id);
        this.getTemplateViewModel().applications(applications);
    }

    public setIsCandidate(isCandidate){

        this.getTemplateViewModel().isCandidate(isCandidate)
    }

    public setPermissions(permissions){

        this.getTemplateViewModel().permissions(permissions)
    }

    public setResultInfo(nbResults, nbPages, execTime, updateExecTime = true) {

        if(updateExecTime) this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public setBrands(filterList: Array<{ id: number, name: string }>): void {

        this.filterBrandType.setItems(filterList);
    }

    public setHrStatus(filterList: Array<{ id: number, name: string }>): void {

        this.filterHrStatusType.setItems(filterList);
    }

    public setStatus(filterList: Array<{ id: number, name: string }>): void {

        this.filterStatusType.setItems(filterList);
    }

    public setProfiles(filterList: Array<{ id: number, name: string }>): void {

        this.filterProfileType.setItems(filterList);
    }

    public onChangeFilterAction() {

        this.caller.filterSimpleOnChange();
    }

    public setSelectedStatus(filterList: Array<{ id: number }>): void {

        this.filterStatusType.setSelectedItems(filterList);
    }

    public setSelectedBrands(filterList: Array<{ id: number }>): void {

        this.filterBrandType.setSelectedItems(filterList);
    }

    public setSearchPresets(presets){

        this.filterPreset.setSearchPresets(presets);
    }

    public addCreatedPresetToList(response){

        this.filterPreset.addCreatedPresetToList(response);
    }

    public setPreferences(preferences){

        this.initialPreferences = JSON.parse(JSON.stringify(preferences));
        this.getTemplateViewModel().preferences(preferences);
    }


    public setViewModelFromRequest(urlParams){

        //check if URL has filters or user preferences
        if (urlParams != null){

            this.setFilterSelectedItems(this.filterBrandType, urlParams.brandIds);
            this.setFilterSelectedItems(this.filterProfileType, urlParams.profileIds);
            this.setFilterSelectedItems(this.filterStatusType, urlParams.statusIds);
            this.setFilterSelectedItems(this.filterHrStatusType, urlParams.hrStatusIds);
        }
    }

    public setFilterSelectedItems(objFilter, urlParams){

        let splitString = [];

        // Multi select filters.
        if(urlParams){
            if(typeof urlParams == "string"){
                splitString = urlParams.split(",");
            }else{
                splitString = [urlParams];
            }
            let arrayParam = [];
            let idTagArray = [];
            splitString.forEach((id) => {
                if(!isNaN(Number(id))){
                    id = Number(id);
                }else{
                    id = id.replaceAll("+", " ");
                }
                arrayParam.push({ id: id });
                idTagArray.push(id);
            });
            objFilter.setSelectedItems(arrayParam);
            objFilter.setTags(idTagArray, objFilter.getItems());
        }else{
            objFilter.setSelectedItems([]);
            objFilter.setTags([], objFilter.getItems());
        }
    }

    public setPaginationIsVisible(isVisible){
        this.getTemplateViewModel().paginationIsVisible(isVisible);
    }

    public setExecutionTime(execTime){

        this.resultInfos.setExecutionTime(execTime);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/jobApplicationsList_template.ts